<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.45834 17.9167H5.00001C4.55798 17.9167 4.13406 17.7411 3.82149 17.4285C3.50893 17.116 3.33334 16.692 3.33334 16.25V2.91667C3.33334 2.47465 3.50893 2.05072 3.82149 1.73816C4.13406 1.4256 4.55798 1.25001 5.00001 1.25001H11.6667C11.9307 1.24936 12.1923 1.30101 12.4363 1.40199C12.6804 1.50297 12.9019 1.65127 13.0883 1.83834L16.0783 4.82834C16.2654 5.01473 16.4137 5.23633 16.5147 5.48033C16.6157 5.72434 16.6673 5.98593 16.6667 6.25001V10.7083"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6667 1.25V5.41667C11.6667 5.63768 11.7545 5.84964 11.9107 6.00592C12.067 6.1622 12.279 6.25 12.5 6.25H16.6667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6667 15.4165H16.6667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.1667 12.9165V17.9165"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconFilePlus',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
